module.exports = __webpack_public_path__ + "img/share.9336298e.svg";